import { render, staticRenderFns } from "./paymentsList.vue?vue&type=template&id=36f489b8&scoped=true&"
import script from "./paymentsList.vue?vue&type=script&lang=js&"
export * from "./paymentsList.vue?vue&type=script&lang=js&"
import style0 from "./paymentsList.vue?vue&type=style&index=0&id=36f489b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f489b8",
  null
  
)

export default component.exports